import Vue from 'vue'
import Router from 'vue-router'

// 路由懒加载：每个页面单独打包成 chunk，按需加载，避免全部塞进 app.js
var HomeSwitch = function () { return import(/* webpackChunkName: "home" */ '@/components/HomeSwitch') }
var Home = function () { return import(/* webpackChunkName: "home-pc" */ '@/components/Home') }
var Mobile = function () { return import(/* webpackChunkName: "home-m" */ '@/components/Mobile') }
var AllProduct = function () { return import(/* webpackChunkName: "product" */ '@/components/AllProduct') }
var AllGame = function () { return import(/* webpackChunkName: "allGame" */ '@/components/AllGame') }
var Page2 = function () { return import(/* webpackChunkName: "page2" */ '@/components/Page2') }
var Page3 = function () { return import(/* webpackChunkName: "page3" */ '@/components/Page3') }
var Intro = function () { return import(/* webpackChunkName: "intro" */ '@/components/Intro') }
var Complaint = function () { return import(/* webpackChunkName: "complaint" */ '@/components/Complaint') }
var ComplaintList = function () { return import(/* webpackChunkName: "complaint" */ '@/components/ComplaintList') }
var ComplaintDetails = function () { return import(/* webpackChunkName: "complaint" */ '@/components/ComplaintDetails') }
var Success = function () { return import(/* webpackChunkName: "complaint" */ '@/components/Success') }
var Legal = function () { return import(/* webpackChunkName: "legal" */ '@/components/Legal') }

Vue.use(Router)

export default new Router({
  routes: [
    {
      // 同一地址按设备切换：PC → Home，移动端 → Mobile
      path: '/',
      name: 'home',
      component: HomeSwitch
    }, {
      // 强制查看 PC 版
      path: '/pc',
      name: 'homePc',
      component: Home
    }, {
      // 强制查看移动版
      path: '/m',
      name: 'mobile',
      component: Mobile
    }, {
      // 隐私政策 / 用户协议：lang 为 zh-CN | zh-TW | en，缺省时跟随站点当前语言
      path: '/privacy/:lang?',
      name: 'privacy',
      component: Legal,
      meta: { doc: 'privacy' }
    }, {
      path: '/terms/:lang?',
      name: 'terms',
      component: Legal,
      meta: { doc: 'terms' }
    }, {
      path: '/product',
      name: 'allProduct',
      component: AllProduct
    }, {
      path: '/allGame',
      name: 'allGame',
      component: AllGame
    }, {
      path: '/page2',
      name: 'page2',
      component: Page2
    }, {
      path: '/page3',
      name: 'page3',
      component: Page3
    }, {
      path: '/intro',
      name: 'intro',
      component: Intro
    }, {
      path: '/complaint',
      name: 'complaint',
      component: Complaint
    }, {
      path: '/complaintList',
      name: 'complaintList',
      component: ComplaintList
    }, {
      path: '/complaintDetails',
      name: 'complaintDetails',
      component: ComplaintDetails
    }, {
      path: '/success',
      name: 'success',
      component: Success
    }, {
      path: '/static'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js